/**
 * aC Men's Hub のアイテムカタログ API contract（zod schema + 型）。
 * API（apps/api/ac-mens-hub）と Web（apps/web/ac-mens-hub）が共有する。
 *
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business アイテムカタログ（FKU 単位の保有アイテム一覧）の API ↔ Web 型を共有し、二重定義を排除する。
 * @graph-connects none
 */
import { z } from 'zod';
/**
 * @graph-node {Variable}
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business アイテムが対応する季節。phoenix-config constants.json の SUB_SEASON と同じ6区分。
 * @graph-connects none
 */
export const SeasonSchema = z.enum([
    'earlySpring',
    'lateSpring',
    'summer',
    'earlyAutumn',
    'lateAutumn',
    'winter',
]);
/**
 * @graph-node {Variable}
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business アイテムカタログ1件のスキーマ。FKU（型×色）単位で、サイズ展開・保有数・貸出可能数・正面画像・対応季節を持つ。
 * @graph-connects none
 */
export const ItemCatalogEntrySchema = z.object({
    fkuCode: z.string(),
    itemName: z.string(),
    brandName: z.string(),
    categoryName: z.string(),
    colorName: z.string(),
    sizes: z.array(z.string()),
    holdingCount: z.number(),
    availableCount: z.number(),
    frontImageUrl: z.string().nullable(),
    seasons: z.array(SeasonSchema),
});
/**
 * @graph-node {Variable}
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business アイテムカタログ一覧のレスポンススキーマ。保有中の全アイテムと取得時刻を返す。
 * @graph-connects none
 */
export const ItemCatalogResponseSchema = z.object({
    items: z.array(ItemCatalogEntrySchema),
    totalCount: z.number(),
    snapshotAt: z.string(),
});
//# sourceMappingURL=item-catalog.js.map